module.exports = __webpack_public_path__ + "img/shipo-map-bridge-red.d832158e.svg";